export default __webpack_public_path__ + "static/media/transfer-postings-active.81a58f39.svg";